import { SingleModeBetSlipTab } from '@/interface/enum';

export type BetSlipGaSize = 'Mini' | 'Md' | 'Big';

export function getBetSlipGaSizePrefix(size: BetSlipGaSize): string {
    return `BetSlip_${size}`;
}

export function getBetSlipGaClassPrefix(size: BetSlipGaSize, tab: SingleModeBetSlipTab): string {
    const tabName = tab === SingleModeBetSlipTab.Single ? 'Single' : 'Parlay';
    return `${getBetSlipGaSizePrefix(size)}${tabName}`;
}
